<template>
  <page>

    <template slot='content'>
      <div class="pl-2">
        <h1>{{ this.$t('Bem vindo(a) ao Terminal da Borracharia!') }}&#128666;&#128640;</h1>
      </div>
      <div class="pl-2">
        <p style="font-size: 20px">{{ this.$t('Realize a gestão de pneus pelo novo terminal da borracharia!')}} &#128515;</p>
      </div>

      <div v-if="getPneusEstoque == 'loading' "  id="div-loader">
        <div id="loader">
          <p style="font-size: 29px; font-weight: 400">{{ $t('Carregando') }}!</p>
          <div class="spin-loader" aria-hidden="true">
            <img src="../../assets/wheel_branco.png" alt="" class="loader-image" width="120">
          </div>
        </div>
        <div>
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
      </div>


      <div v-if="getPneusEstoque != 'loading'" class="col-12 row container">
          <div class="col colunaDashboard">
            <div class="card divCard" :style="bgDivCard">
              <div class="title-card">
                {{ this.$t('Aderência Aferição 01') }}<br> de MM %'
              </div>
              <hr>
              <div class="body-card">
                <h3>{{ getPercentualAfericaoMes.toFixed(2) * 100 }}%</h3>
                <!-- <img class="icon-dash" src="../../assets/pneu_dash_01.png" alt="" width="55" height="55"> -->
              </div>
            </div>
          </div>

          <div class="col colunaDashboard">
            <div class="card divCard">
              <div class="title-card">
                {{ this.$t('Aderência Aferição 02') }} <br>{{ this.$t('de Calibragem') }}%
              </div>
              <hr>
              <div class="body-card">
                <h3>{{ getPercentualCalibragemMes.toFixed(2) }}%</h3>
                <!-- <img class="icon-dash" src="../../assets/pneu_dash_01.png" alt="" width="55" height="55"> -->
              </div>
            </div>
          </div>

          <!-- <div class="col colunaDashboard">
            <div class="card divCard">
              <div class="title-card">
                Total Pneus <br> Rodando
              </div>
              <hr>
              <div class="body-card">
                <h3>{{ getPneusRodando.length }}</h3>
              </div>
            </div>
          </div> -->

          <!-- <div class="col colunaDashboard">
            <div class="card divCard">
              <div class="title-card">
                Total Pneus <br> Descarte
              </div>
              <hr>
              <div class="body-card">
                <h3>{{ getPneusDescarte.length }}</h3>
              </div>
            </div>
          </div>
          <div class="col colunaDashboard">
            <div class="card divCard">
              <div class="title-card">
                Total Pneus <br> Recapadora
              </div>
              <hr>
              <div class="body-card">
                <h3>{{ getPneusRecapadora.length }}</h3>
              </div>
            </div>
          </div>

          <div class="col colunaDashboard">
            <div class="card divCard">
              <div class="title-card">
                Total Pneus <br> Estoque
              </div>
              <hr>
              <div class="body-card">
                <h3>{{ getPneusEstoque.length }}</h3>
              </div>
            </div>
          </div> -->

        </div>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'

export default {
  components: {
    Page,
  },
  mounted() {
    this.$store.dispatch('filial/actionSidebar')
  }, 

  computed: {
    bgDivCard() {
      const per = this.$store.getters['borracharia/getPercentualAfericaoMes']
      
      if((per * 100) < 80){
        return 'background: linear-gradient(45deg, #810505, #b35f5f) !important;'
      } 

      if((per * 100) < 100) {
        return 'background: linear-gradient(45deg, #817905, #d2ce6b) !important;'
      }

      return 'background: linear-gradient(45deg, #1e7773, #53a869) !important;'
    },

    getPneusRodando() {
      const pneusRodando = this.$store.getters['borracharia/getPneusRodando']
    
      return pneusRodando
    },

    getPneusDescarte() {
      const pneusDescarte = this.$store.getters['borracharia/getPneusDescarte']

      return pneusDescarte
    },
    getPneusRecapadora() {
      const pneusRecapadora = this.$store.getters['borracharia/getPneusRecapadora']

      return pneusRecapadora
    },
    getPneusEstoque() {
      const pneusEstoque = this.$store.getters['borracharia/getPneusEstoque']

      return pneusEstoque
    },
    getPercentualAfericaoMes() {
      return this.$store.getters['borracharia/getPercentualAfericaoMes']
    },
    getPercentualCalibragemMes() {
      return this.$store.getters['borracharia/getPercentualCalibragemMes']
    }
  },

  created() {
    this.$store.dispatch('borracharia/getDashboard')

  }
}
</script>
<style src="./style.scss" lang="scss">